import { Box, Flex, Text } from '@chakra-ui/react';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@morressier/alembic';
import { recommendationBadges } from 'src/components/Review/Badges';

type IProps = {
  comment: string | undefined;
  Reviewernumber?: number;
  ReviewerName?: string;
  status?: string;
};

export const RoundReview: React.FC<IProps> = ({
  comment,
  Reviewernumber = 1,
  ReviewerName,
  status
}) => {
  return (
    <>
      <Box>
        <Flex justifyContent={'space-between'}>
          <Flex gap={2}>
            <Text
              color={ReviewerName ? 'blue' : undefined}
              textStyle="textBody"
              fontWeight="semibold"
            >
              {ReviewerName ?? ` Anonymous Reviewer ${Reviewernumber}`}
            </Text>
            {ReviewerName && (
              <Badge variant="success" size="context">
                <FontAwesomeIcon icon={faUser} /> You
              </Badge>
            )}
          </Flex>
          <Box>{status && recommendationBadges[status]}</Box>
        </Flex>
      </Box>
      <Box marginY={2} marginX={1}>
        <Text textStyle={'textContext'} fontWeight="semibold">
          Feedback for Authors
        </Text>
      </Box>
      <Box marginX={1}>
        <Text noOfLines={ReviewerName ? 5 : 0} textStyle={'textContext'}>
          {comment}{' '}
        </Text>
      </Box>
    </>
  );
};
